/**
 * Search query hook.
 *
 * Disabled until there is a term to search for, so landing on `/search` with
 * an empty box fires no request — the endpoint would reject a blank `q` as a
 * validation error, and there is nothing to show anyway.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.11
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { SearchQuery, SearchResults } from '@nexus/contracts';

import { queryKeys } from '../../../lib/query-keys';

import * as searchApi from './search.api';

export function useSearch(query: SearchQuery): UseQueryResult<SearchResults> {
  const term = query.q.trim();

  return useQuery({
    queryKey: queryKeys.search.query({ ...query, q: term }),
    queryFn: () => searchApi.search({ ...query, q: term }),
    enabled: term.length > 0,
  });
}
